import { Flex } from '@mantine/core';
import classes from './../../app.module.css';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

export const LoadingPage = ({ icon }: { icon?: false | React.ReactNode }) => {
  document.getElementsByTagName('body')[0].style.backgroundColor =
    'var(--mantine-color-clinicalWhite-0)';

  return (
    <Flex direction={'column'} justify={'center'} style={{ height: '100vh' }}>
      <Flex direction={'row'} justify={'center'} style={{ width: '100vw' }}>
        <div
          className={classes.loader}
          style={{
            position: 'absolute',
            left: 'calc(50vw - 50px)',
            top: 'calc(50vh - 50px)',
          }}
        />
        {icon !== false && icon === undefined ? (
          <HourglassEmptyIcon sx={{ fontSize: 30 }} />
        ) : (
          icon
        )}
      </Flex>
    </Flex>
  );
};
